/* eslint-disable @typescript-eslint/no-explicit-any */
/* istanbul ignore file */
import client, { ApiVersion } from '@web/api/client'
import ShortCourseMapper from '@web/mapper/shortCourseMapper'
import HeaderMapper from '@web/mapper/HeaderMapper'

import { IShortCourseSearchResponse } from '@web/store/types/modules/shortCourse'

export default class ShortCourseApi {
  /**
   * Поиск курсов с фильтрацией и пагинацией
   *
   * @param textSearch {string} - Текст для поиска
   * @param categoryId {number} - ID категории для фильтрации
   * @param cids {number[]} - Массив ID курсов для фильтрации
   * @param page {number} - Номер страницы для пагинации (по умолчанию 1)
   * @param perPage {number} - Количество элементов на странице (по умолчанию 8)
   * @param withOffer {boolean} - Запросить оффер и контент лендинга по курсу (по умолчанию false)
   * @returns {Promise<{ data: IShortCourseSearchResponse; headers: Headers }>}
   */
  static search ({
    textSearch,
    tagId,
    cids = [],
    page = 1,
    perPage = 8,
    withOffer = false
  }: {
    textSearch?: string;
    tagId?: number;
    cids?: number[];
    page?: number;
    perPage?: number;
    withOffer?: boolean;
  }): Promise<{
    data: IShortCourseSearchResponse;
    headers: Headers;
  }> {
    const params: Record<string, any> = {}

    if (textSearch) params.textSearch = textSearch
    if (tagId) params.tagId = tagId
    if (page) params.page = page
    if (perPage) params.perPage = perPage
    if (withOffer) params.withOffer = true

    if (cids.length > 0) {
      params.cids = cids
    }

    return client.post('/course/search', params, ApiVersion.v2)
      .then(response => {
        return {
          data: ShortCourseMapper.toClient(response.data.data),
          headers: HeaderMapper.toClient(response.headers)
        }
      })
  }
}
